export const FIELD_ACTION_LABELS = {
  visibility: "Visibility",
  conditionalLogic: "Conditional logic",
  duplicate: "Duplicate field",
  delete: "Delete field",
} as const;

export const BUILDER_LABELS = {
  removeRule: "Remove rule",
  addPage: "Add page",
  unit: "Unit",
  paletteHint: "Click or drag a field to add it",
  paletteHintTouch: "Tap a field to add it",
  emptyQuestionWarning: "Add a question — it's required to publish",
  propertiesNeedsField: "Select a field first",
  previewAnyProvider: "Service provider (any)",
  emptyQuestionPlaceholder: "Untitled question. Type the question",
  emptyStateDesktop: "Click or drag a field from the left panel, or",
  emptyStateTrigger: "pick a field type",
} as const;

export const EMPTY_OPTION_PLACEHOLDER = "Type option text";

export const optionLabel = (value: string | undefined): string => value || EMPTY_OPTION_PLACEHOLDER;

export const INLINE_HIT_AREA = { "data-inline-hit": "" };
